var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.card)?_c('nuxt-link',{staticClass:"card-data",attrs:{"to":_vm.$prismic.linkResolver(_vm.card)}},[_c('PrismicImage',{attrs:{"img":_vm.card.data.card_image,"w":"220","h":"140"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.card.data.title))]),_vm._v(" "),_c('CardStarsWithCount',{attrs:{"data":_vm.model._ratings}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }